import React from 'react';
import NarrativeReportsTab from './NarrativeReportsTab';

const NarrativeReportsViews = () => {
  return <NarrativeReportsTab />;
};

export default NarrativeReportsViews;
